import React from 'react';

const LogoSlider = () => {
  return (
    <div className="slider">
        <div className="slide-track"> 
        <div className="slide">
            <img src="/images/ip/tb.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/tew.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/wp.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/tlc.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/vpsc.png" width="175" alt="" />
        </div>           
        <div className="slide">
            <img src="/images/ip/gi.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/ied.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/ss.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/cura.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/dp.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/acwa.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/hf.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/web.png" width="175" alt="" />
        </div>
        <div className="slide">
            <img src="/images/ip/sw.png" width="175" alt="" />
        </div>
        </div>
    </div>
  );
};

export default LogoSlider;
